import * as React from 'react';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { descriptions } from './description-list';
import './DescriptionSelector.scss';
export default function DescriptionSelector(props) {
  return (
    <Stack spacing={3} sx={{ width: '100%',marginBottom:'30px',backgroundColor:'white', borderRadius:'6px' }}>
           <Autocomplete sx={{backgroundColor:''}}
        multiple
        fullWidth
        disablePortal={true}
        id="tags-filled"
        options={descriptions.map((option) => option.title)}
       // defaultValue={[descriptions[13].title]}
        freeSolo
        value={(props.formData && props.formData.additional_info)?props.formData.additional_info:[]}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => {
            const { key, ...tagProps } = getTagProps({ index });
            return (
              <Chip variant="outlined" label={option} key={key} {...tagProps} />
            );
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            className="custom-input-style"
            variant="filled"
            label="Choose or type your own description"
            placeholder=""
          />

        )}
        onChange={(event, newValue) => {console.log(newValue);props.setFormData({...props.formData, additional_info: newValue})}}
      />
      
    </Stack>
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
